import React, { ComponentPropsWithoutRef, ForwardedRef, forwardRef, ReactNode } from 'react'

import { bemJoin, classNames } from '@app/lib/bem'

import { DropdownMenuSize } from './types'

const b = bemJoin('dropdown-menu')

export type MenuItemContentProps = ComponentPropsWithoutRef<'div'> & {
  label: ReactNode
  leading?: ReactNode
  comment?: ReactNode
  trailing?: ReactNode
  size?: DropdownMenuSize
  selected?: boolean
  disabled?: boolean
}

export const MenuItemContent = forwardRef(
  (
    {
      label,
      leading,
      comment,
      trailing,
      size = 'md',
      selected = false,
      disabled = false,
      className,
      ...rest
    }: MenuItemContentProps,
    ref: ForwardedRef<HTMLDivElement>
  ) => {
    return (
      <div
        ref={ref}
        className={classNames(
          b('item', {
            [size]: true,
            selected,
            disabled
          }),
          className
        )}
        {...rest}
      >
        {leading !== undefined && <span className={b('leading', { [size]: true })}>{leading}</span>}
        <span className={b('label')}>{label}</span>
        {comment !== undefined && <span className={b('comment')}>{comment}</span>}
        {trailing !== undefined && <span className={b('trailing')}>{trailing}</span>}
      </div>
    )
  }
)
